import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="권한이 없습니다"
      subTitle="이 페이지에 접근할 권한이 없습니다. 필요한 권한이 있는 계정으로 로그인해 주세요."
      extra={<Button type="primary" onClick={() => navigate('/dashboard')}>대시보드로 이동</Button>}
    />
  );
};

export default UnauthorizedPage;

